export default "__VITE_ASSET__2afad810__"